import * as React from 'react'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DialogBodyProps } from '@fluentui/react-dialog'
import useAxios from '../../../../hooks/useAxios'
import { Button, DialogActions, DialogBody, DialogContent, DialogTitle, DialogTrigger, Image } from '@fluentui/react-components'
import { HammockDialogProps } from '../HammockDialog'
import { Destination } from '../../../../context/AxiosContext'
import { DriveItem } from '@microsoft/microsoft-graph-types'
import Loading from '../../../../components/Loading'

export type PreviewDocumentDialogBodyProps = DialogBodyProps & {
    driveItem: DriveItem
}

export default function PreviewDocumentDialogBody(props: HammockDialogProps<PreviewDocumentDialogBodyProps>) {
    const axios = useAxios()
    const { t: translate } = useTranslation()

    const dialogBodyProps = useMemo(() => props.dialogBodyProps?.() ?? ({} as PreviewDocumentDialogBodyProps), [props])

    const [preview, setPreview] = useState<string>(undefined)

    useEffect(() => {
        axios
            .get(`/items/${dialogBodyProps?.driveItem.id}/thumbnails/0/large`, {
                baseURL: Destination.Documents,
            })
            .then(response => setPreview(response.data.url))
    }, [])

    return (
        <DialogBody>
            <DialogTitle>{translate('file.pivot.document.mutate.preview.button')}</DialogTitle>
            <DialogContent>
                {!preview && <Loading />}
                {preview && <Image src={preview} block bordered fit={'contain'} shape={'rounded'} />}
            </DialogContent>
            <DialogActions>
                <DialogTrigger disableButtonEnhancement>
                    <Button appearance="secondary">{translate('action.close')}</Button>
                </DialogTrigger>
            </DialogActions>
        </DialogBody>
    )
}
